import { IBadgeType } from "@repo/core/components/core/Badge/types";
import {
  MartialStatusEnum,
  ProposalCardStatusEnum,
  RelationshipEnum
} from "@repo/core/enums/proposals";
import { TIPO_PESSOA } from "@repo/core/services/entities/Proposals";

export const WayupProposalStatusInternal = {
  "01": ProposalCardStatusEnum.IN_PROGRESS,
  "02": ProposalCardStatusEnum.IN_PROGRESS,
  "03": ProposalCardStatusEnum.IN_PROGRESS,
  "04": ProposalCardStatusEnum.ANALYSIS_CREDIT_DESK,
  "05": ProposalCardStatusEnum.APROVED,
  "06": ProposalCardStatusEnum.APROVED_CREDIT_DESK,
  "07": ProposalCardStatusEnum.REJECTED,
  "08": ProposalCardStatusEnum.REJECTED,
  "09": ProposalCardStatusEnum.IN_PROGRESS,
  "10": ProposalCardStatusEnum.IN_PROGRESS,
  "11": ProposalCardStatusEnum.EFFECTIVE,
  "12": ProposalCardStatusEnum.REJECTED_CREDIT_DESK,
  "13": ProposalCardStatusEnum.IN_PROGRESS,
  "14": ProposalCardStatusEnum.INACTIVE,
  "15": ProposalCardStatusEnum.IN_PROGRESS,
  "16": ProposalCardStatusEnum.APROVED,
  "17": ProposalCardStatusEnum.REJECTED,
  "18": ProposalCardStatusEnum.IN_PROGRESS,
  "19": ProposalCardStatusEnum.IN_PROGRESS,
  "20": ProposalCardStatusEnum.IN_PROGRESS
};

/**
 * Mapping of proposal status codes to their descriptions
 * Used as fallback when API doesn't return strSituacaoDescricao
 */
export const ProposalStatusDescriptions: Record<string, string> = {
  "01": "Fila de Análise Automática",
  "02": "Em Espera para Análise",
  "03": "Em Análise Automática",
  "04": "Em Análise Manual",
  "05": "Aprovada Automaticamente",
  "06": "Aprovada Manualmente",
  "07": "Reprovada Automaticamente",
  "08": "Reprovada Manualmente",
  "09": "Com pendências de Correção",
  "10": "Com pendências de Análise",
  "11": "Efetivada",
  "12": "Fila de Análise Manual",
  "13": "Com Erro de Análise",
  "14": "Cancelada",
  "15": "Pré-Proposta",
  "16": "Pré-Proposta Aprovada",
  "17": "Pré-Proposta Reprovada",
  "18": "Pré-Proposta em Análise",
  "19": "Conferência de Documentos",
  "20": "Conferência de Cadastro"
};

export const ProposalStatusByCode = {
  5: ProposalCardStatusEnum.APROVED,
  8: ProposalCardStatusEnum.REJECTED_CREDIT_DESK,
  4: ProposalCardStatusEnum.ANALYSIS_CREDIT_DESK
};

export const RelationshipByCode = {
  1: RelationshipEnum.DAD_MOTHER,
  2: RelationshipEnum.BROTHER_SISTER,
  3: RelationshipEnum.UNCLE_AUNT,
  4: RelationshipEnum.GRANDFATHER_GRANDMOTHER,
  5: RelationshipEnum.GRANDSON_GRANDDAUGHTER,
  6: RelationshipEnum.FRIENDS,
  7: RelationshipEnum.COLLEAGUE,
  8: RelationshipEnum.NEPHEW_NUN,
  9: RelationshipEnum.NIECE_NEPHEW,
  10: RelationshipEnum.SON_DAUGHTER,
  11: RelationshipEnum.COUPLE,
  12: RelationshipEnum.NEIGHBOR
};

export enum ProposalTypeByCode {
  AMBOS = "A",
  FIDELIDADE = "F"
}

export const ResidenceTypeOptions = [
  { label: "PROPRIA QUITADA", value: "1" },
  { label: "PROPRIA FINANCIADA", value: "2" },
  { label: "ALUGADA", value: "3" },
  { label: "COM OS PAIS", value: "4" },
  { label: "OUTROS", value: "6" },
  { label: "FUNCIONAL", value: "8" }
];

export const RelationshipByCodeReverse = {
  [RelationshipEnum.DAD_MOTHER]: 1,
  [RelationshipEnum.BROTHER_SISTER]: 2,
  [RelationshipEnum.UNCLE_AUNT]: 3,
  [RelationshipEnum.GRANDFATHER_GRANDMOTHER]: 4,
  [RelationshipEnum.GRANDSON_GRANDDAUGHTER]: 5,
  [RelationshipEnum.FRIENDS]: 6,
  [RelationshipEnum.COLLEAGUE]: 7,
  [RelationshipEnum.NEPHEW_NUN]: 8,
  [RelationshipEnum.NIECE_NEPHEW]: 9,
  [RelationshipEnum.SON_DAUGHTER]: 10,
  [RelationshipEnum.COUPLE]: 11,
  [RelationshipEnum.NEIGHBOR]: 12
};

export const ProposalStatusByName = {
  [ProposalCardStatusEnum.APROVED]: 5,
  [ProposalCardStatusEnum.REJECTED_CREDIT_DESK]: 8,
  [ProposalCardStatusEnum.ANALYSIS_CREDIT_DESK]: 4
};

export const StatusBadge = {
  [ProposalCardStatusEnum.APROVED]: {
    text: "5 - Aprovada",
    type: IBadgeType.success
  },
  [ProposalCardStatusEnum.REJECTED]: {
    text: "7 - Reprovada",
    type: IBadgeType.error
  },
  [ProposalCardStatusEnum.IN_PROGRESS]: {
    text: "20 - Em andamento",
    type: IBadgeType.warning
  },
  [ProposalCardStatusEnum.EFFECTIVE]: {
    text: "11 - Efetivada",
    type: IBadgeType.info
  },
  [ProposalCardStatusEnum.INACTIVE]: {
    text: "14 - Inativo",
    type: IBadgeType.muted
  },
  [ProposalCardStatusEnum.REJECTED_CREDIT_DESK]: {
    text: "8 - Reprovada na Mesa de Crédito",
    type: IBadgeType.error
  },
  [ProposalCardStatusEnum.ANALYSIS_CREDIT_DESK]: {
    text: "4 - Em análise na Mesa de Crédito",
    type: IBadgeType.analysis
  },
  [ProposalCardStatusEnum.APROVED_CREDIT_DESK]: {
    text: "6 - Aprovada na mesa de Crédito",
    type: IBadgeType.success
  },
  [ProposalCardStatusEnum.DRAFT]: {
    text: "Rascunho",
    type: IBadgeType.draft
  }
};

export const professionalCategoryOptions = [
  { label: "Trabalhador Assalariado", value: "Trabalhador Assalariado" },
  { label: "Profissional Liberal", value: "Profissional Liberal" },
  { label: "Trabalhador Autônomo", value: "Trabalhador Autônomo" },
  { label: "Trabalho Voluntário", value: "Trabalho Voluntário" },
  { label: "Empregado Doméstico", value: "Empregado Doméstico" },
  { label: "Estágio Profissional", value: "Estágio Profissional" },
  { label: "Trabalho Informal", value: "Trabalho Informal" }
];

export const professions = [
  { value: "Administrador", label: "Administrador" },
  { value: "Advogado", label: "Advogado" },
  { value: "Agenciador", label: "Agenciador" },
  { value: "Agente", label: "Agente" },
  { value: "Agrônomo", label: "Agrônomo" },
  { value: "Alfaiate", label: "Alfaiate" },
  { value: "Analista", label: "Analista" },
  { value: "Aposentado", label: "Aposentado" },
  { value: "Arquiteto", label: "Arquiteto" },
  { value: "Assistente", label: "Assistente" },
  { value: "Astrônomo", label: "Astrônomo" },
  { value: "Atleta", label: "Atleta" },
  { value: "Ator", label: "Ator" },
  { value: "Auxiliar", label: "Auxiliar" },
  { value: "Bailarino", label: "Bailarino" },
  { value: "Bancário", label: "Bancário" },
  { value: "Bibliotecário", label: "Bibliotecário" },
  { value: "Biólogo", label: "Biólogo" },
  { value: "Cabeleireiro", label: "Cabeleireiro" },
  { value: "Operador De Caixa", label: "Operador De Caixa" },
  { value: "Câmera", label: "Câmera" },
  { value: "Cantor", label: "Cantor" },
  {
    value: "Capitalista Ativos Financeiros",
    label: "Capitalista Ativos Financeiros"
  },
  { value: "Chefe", label: "Chefe" },
  { value: "Comandante", label: "Comandante" },
  { value: "Comerciante", label: "Comerciante" },
  { value: "Comerciário", label: "Comerciário" },
  { value: "Comissário", label: "Comissário" },
  { value: "Comprador", label: "Comprador" },
  { value: "Contador", label: "Contador" },
  { value: "Corretor", label: "Corretor" },
  { value: "Costureiro", label: "Costureiro" },
  { value: "Decorador", label: "Decorador" },
  { value: "Delegado", label: "Delegado" },
  { value: "Demonstrador", label: "Demonstrador" },
  { value: "Dentista", label: "Dentista" },
  { value: "Desenhista", label: "Desenhista" },
  { value: "Despachante", label: "Despachante" },
  { value: "Diretor", label: "Diretor" },
  { value: "Economista", label: "Economista" },
  { value: "Eletricista", label: "Eletricista" },
  { value: "Enfermeiro", label: "Enfermeiro" },
  { value: "Engenheiro", label: "Engenheiro" },
  { value: "Escultor", label: "Escultor" },
  { value: "Estatístico", label: "Estatístico" },
  { value: "Estudantes", label: "Estudantes" },
  { value: "Farmacêutico", label: "Farmacêutico" },
  { value: "Feirante", label: "Feirante" },
  { value: "Fiscal", label: "Fiscal" },
  { value: "Físico", label: "Físico" },
  { value: "Fisioterapeuta", label: "Fisioterapeuta" },
  { value: "Fonoaudiólogo", label: "Fonoaudiólogo" },
  { value: "Fotógrafo", label: "Fotógrafo" },
  { value: "Funcionário Público", label: "Funcionário Público" },
  { value: "Garçom", label: "Garçom" },
  { value: "Garimpeiro", label: "Garimpeiro" },
  { value: "Geógrafo", label: "Geógrafo" },
  { value: "Geólogo", label: "Geólogo" },
  { value: "Gerente", label: "Gerente" },
  { value: "Guia", label: "Guia" },
  { value: "Industriário", label: "Industriário" },
  { value: "Joalheiros", label: "Joalheiros" },
  { value: "Jornaleiro", label: "Jornaleiro" },
  { value: "Jornalista", label: "Jornalista" },
  { value: "Juiz", label: "Juiz" },
  { value: "Oficial De Justiça", label: "Oficial De Justiça" },
  { value: "Leiloeiro", label: "Leiloeiro" },
  { value: "Professor De Letras", label: "Professor De Letras" },
  { value: "Locutor", label: "Locutor" },
  { value: "Maquinista", label: "Maquinista" },
  { value: "Marinheiro", label: "Marinheiro" },
  { value: "Matemático", label: "Matemático" },
  { value: "Mecânico", label: "Mecânico" },
  { value: "Médico", label: "Médico" },
  { value: "Mestre", label: "Mestre" },
  { value: "Metalúrgico", label: "Metalúrgico" },
  { value: "Militar", label: "Militar" },
  { value: "Modelo", label: "Modelo" },
  { value: "Motorista", label: "Motorista" },
  { value: "Músico", label: "Músico" },
  { value: "Odontólogo", label: "Odontólogo" },
  { value: "Oficial Das Forças Armadas", label: "Oficial Das Forças Armadas" },
  { value: "Operador De Computadores", label: "Operador De Computadores" },
  { value: "Outras", label: "Outras" },
  { value: "Pecuarista", label: "Pecuarista" },
  { value: "Pensionista", label: "Pensionista" },
  { value: "Piloto Aeronáutico", label: "Piloto Aeronáutico" },
  { value: "Político", label: "Político" },
  { value: "Procurador", label: "Procurador" },
  {
    value: "Professor De Ensino Superior",
    label: "Professor De Ensino Superior"
  },
  {
    value: "Professor Ensino Fundamental E Médio",
    label: "Professor Ensino Fundamental E Médio"
  },
  {
    value: "Diretor De Estabelecimento De Ensino",
    label: "Diretor De Estabelecimento De Ensino"
  },
  {
    value: "Proprietário De Estab. Comercial",
    label: "Proprietário De Estab. Comercial"
  },
  {
    value: "Proprietário De Estab. Industrial",
    label: "Proprietário De Estab. Industrial"
  },
  {
    value: "Proprietário De Estab. Prestação De Serviço",
    label: "Proprietário De Estab. Prestação De Serviço"
  },
  { value: "Psicólogo", label: "Psicólogo" },
  { value: "Publicitário", label: "Publicitário" },
  { value: "Químico", label: "Químico" },
  { value: "Reformado", label: "Reformado" },
  { value: "Relações Públicas", label: "Relações Públicas" },
  { value: "Representante Comercial", label: "Representante Comercial" },
  { value: "Secretário", label: "Secretário" },
  { value: "Securitário", label: "Securitário" },
  { value: "Sociólogo", label: "Sociólogo" },
  { value: "Tabelião", label: "Tabelião" },
  {
    value: "Técnicos De Contabilidade E Estatística",
    label: "Técnicos De Contabilidade E Estatística"
  },
  { value: "Técnico De Biologia", label: "Técnico De Biologia" },
  {
    value: "Técnico Em Agronomia E Agrimensura",
    label: "Técnico Em Agronomia E Agrimensura"
  },
  { value: "Técnico Em Química", label: "Técnico Em Química" },
  { value: "Técnico Em Mecânica", label: "Técnico Em Mecânica" },
  {
    value: "Técnico Em Eletricidade E Telecomunicações",
    label: "Técnico Em Eletricidade E Telecomunicações"
  },
  {
    value: "Técnico De Laboratório E Raio X",
    label: "Técnico De Laboratório E Raio X"
  },
  { value: "Desenhista Técnico", label: "Desenhista Técnico" },
  { value: "Telefonista", label: "Telefonista" },
  { value: "Vendedor", label: "Vendedor" },
  { value: "Veterinário", label: "Veterinário" },
  { value: "Vigilante", label: "Vigilante" },
  {
    value: "Representante Comercial Autônomo",
    label: "Representante Comercial Autônomo"
  },
  { value: "Zelador", label: "Zelador" },
  { value: "Nutricionista", label: "Nutricionista" },
  { value: "Matrizeiro", label: "Matrizeiro" },
  { value: "Governanta", label: "Governanta" },
  {
    value: "Auxiliar De Serviços Gerais",
    label: "Auxiliar De Serviços Gerais"
  },
  { value: "Empregada Doméstica", label: "Empregada Doméstica" },
  { value: "Recebimento De Aluguel", label: "Recebimento De Aluguel" },
  { value: "Motorista Particular", label: "Motorista Particular" },
  { value: "Do Lar", label: "Do Lar" },
  { value: "Acompanhante", label: "Acompanhante" },
  { value: "Açougueiro", label: "Açougueiro" },
  { value: "Acupuntor", label: "Acupuntor" },
  { value: "Aeromoça", label: "Aeromoça" },
  { value: "Agente Comunitário", label: "Agente Comunitário" },
  { value: "Agente De Estação", label: "Agente De Estação" },
  { value: "Agente De Polícia", label: "Agente De Polícia" },
  { value: "Agente De Saúde", label: "Agente De Saúde" },
  { value: "Agente De Trânsito", label: "Agente De Trânsito" },
  { value: "Agente De Viagem", label: "Agente De Viagem" },
  { value: "Agente Funerário", label: "Agente Funerário" },
  { value: "Ajudante", label: "Ajudante" },
  { value: "Ajudante De Manutenção", label: "Ajudante De Manutenção" },
  { value: "Ajudante De Obras", label: "Ajudante De Obras" },
  { value: "Almoxarife", label: "Almoxarife" },
  { value: "Analista De Câmbio", label: "Analista De Câmbio" },
  { value: "Analista De Cobrança", label: "Analista De Cobrança" },
  { value: "Analista Comercial", label: "Analista Comercial" },
  { value: "Analista De Crédito", label: "Analista De Crédito" },
  { value: "Analista De Negócio", label: "Analista De Negócio" },
  { value: "Analista De Pesquisa", label: "Analista De Pesquisa" },
  { value: "Analista De Redes", label: "Analista De Redes" },
  { value: "Analista De Rh", label: "Analista De Rh" },
  { value: "Analista De Ti", label: "Analista De Ti" },
  { value: "Analista Financeiro", label: "Analista Financeiro" },
  { value: "Antropólogo", label: "Antropólogo" },
  { value: "Árbitro", label: "Árbitro" },
  { value: "Arqueólogo", label: "Arqueólogo" },
  { value: "Arquivista", label: "Arquivista" },
  { value: "Artesão", label: "Artesão" },
  { value: "Artista Plástico", label: "Artista Plástico" },
  { value: "Ascensorista", label: "Ascensorista" },
  { value: "Assessor", label: "Assessor" },
  { value: "Assessor Comercial", label: "Assessor Comercial" },
  { value: "Assistente Jurídico", label: "Assistente Jurídico" },
  { value: "Assistente Administrativo", label: "Assistente Administrativo" },
  { value: "Assistente De Veterinário", label: "Assistente De Veterinário" },
  { value: "Assistente Judiciário", label: "Assistente Judiciário" },
  { value: "Assistente Social", label: "Assistente Social" },
  { value: "Assistente De Laboratório", label: "Assistente De Laboratório" },
  { value: "Astrólogo", label: "Astrólogo" },
  { value: "Atendente Comercial", label: "Atendente Comercial" },
  { value: "Atendente De Farmácia", label: "Atendente De Farmácia" },
  { value: "Atuário", label: "Atuário" },
  { value: "Auditor", label: "Auditor" },
  { value: "Auxiliar De Biblioteca", label: "Auxiliar De Biblioteca" },
  { value: "Auxiliar De Cobrança", label: "Auxiliar De Cobrança" },
  { value: "Auxiliar De Compras", label: "Auxiliar De Compras" },
  { value: "Auxiliar De Cozinha", label: "Auxiliar De Cozinha" },
  { value: "Auxiliar De Creche", label: "Auxiliar De Creche" },
  { value: "Auxiliar De Crédito", label: "Auxiliar De Crédito" },
  { value: "Auxiliar De Depósito", label: "Auxiliar De Depósito" },
  { value: "Auxiliar De Educação", label: "Auxiliar De Educação" },
  { value: "Auxiliar De Enfermagem", label: "Auxiliar De Enfermagem" },
  { value: "Auxiliar De Escritório", label: "Auxiliar De Escritório" },
  { value: "Auxiliar De Estoque", label: "Auxiliar De Estoque" },
  { value: "Auxiliar De Expedição", label: "Auxiliar De Expedição" },
  { value: "Auxiliar De Exportação", label: "Auxiliar De Exportação" },
  { value: "Auxiliar De Laboratório", label: "Auxiliar De Laboratório" },
  { value: "Auxiliar De Lavanderia", label: "Auxiliar De Lavanderia" },
  { value: "Auxiliar De Limpeza", label: "Auxiliar De Limpeza" },
  { value: "Auxiliar De Loja", label: "Auxiliar De Loja" },
  { value: "Auxiliar De Manutenção", label: "Auxiliar De Manutenção" },
  { value: "Auxiliar De Montagem", label: "Auxiliar De Montagem" },
  { value: "Auxiliar De Produção", label: "Auxiliar De Produção" },
  { value: "Auxiliar De Tesouraria", label: "Auxiliar De Tesouraria" },
  { value: "Auxiliar De Vendas", label: "Auxiliar De Vendas" },
  {
    value: "Auxiliar De Departamento Pessoal",
    label: "Auxiliar De Departamento Pessoal"
  },
  { value: "Auxiliar Financeiro", label: "Auxiliar Financeiro" },
  { value: "Auxiliar Judiciário", label: "Auxiliar Judiciário" },
  { value: "Auxiliar Mecânico", label: "Auxiliar Mecânico" },
  { value: "Auxiliar Odontológico", label: "Auxiliar Odontológico" },
  { value: "Auxiliar Técnico", label: "Auxiliar Técnico" },
  {
    value: "Auxílio Doença Previdenciário",
    label: "Auxílio Doença Previdenciário"
  },
  { value: "Azulejista", label: "Azulejista" },
  { value: "Babá", label: "Babá" },
  { value: "Balconista", label: "Balconista" },
  { value: "Biotecnologista", label: "Biotecnologista" },
  { value: "Bombeiro", label: "Bombeiro" },
  { value: "Borracheiro", label: "Borracheiro" },
  { value: "Cabo", label: "Cabo" },
  { value: "Caldeireiro", label: "Caldeireiro" },
  { value: "Camareira", label: "Camareira" },
  { value: "Caminhoneiro", label: "Caminhoneiro" },
  { value: "Capitão Da Marinha", label: "Capitão Da Marinha" },
  { value: "Carpinteiro", label: "Carpinteiro" },
  { value: "Caseiro", label: "Caseiro" },
  { value: "Chapeador", label: "Chapeador" },
  { value: "Chaveiro", label: "Chaveiro" },
  { value: "Chef De Cozinha", label: "Chef De Cozinha" },
  { value: "Chefe De Departamento", label: "Chefe De Departamento" },
  { value: "Chefe De Expedição", label: "Chefe De Expedição" },
  { value: "Chefe De Máquinas Naval", label: "Chefe De Máquinas Naval" },
  { value: "Churrasqueiro", label: "Churrasqueiro" },
  { value: "Cientista Político", label: "Cientista Político" },
  { value: "Cirurgião Dentista", label: "Cirurgião Dentista" },
  { value: "Classificador De Resíduos", label: "Classificador De Resíduos" },
  { value: "Cobrador De Dívidas", label: "Cobrador De Dívidas" },
  { value: "Cobrador De Transporte", label: "Cobrador De Transporte" },
  { value: "Coletor De Lixo", label: "Coletor De Lixo" },
  { value: "Comentarista Radio / Tv", label: "Comentarista Radio / Tv" },
  { value: "Confeiteiro", label: "Confeiteiro" },
  { value: "Conferente", label: "Conferente" },
  { value: "Conselheiro Tutelar", label: "Conselheiro Tutelar" },
  { value: "Construtor Civil", label: "Construtor Civil" },
  { value: "Consultor", label: "Consultor" },
  { value: "Consultor De Vendas", label: "Consultor De Vendas" },
  { value: "Contínuo", label: "Contínuo" },
  { value: "Contramestre", label: "Contramestre" },
  { value: "Controlador", label: "Controlador" },
  { value: "Coordenador", label: "Coordenador" },
  { value: "Coordenador De Vendas", label: "Coordenador De Vendas" },
  { value: "Copeiro", label: "Copeiro" },
  { value: "Coreógrafo", label: "Coreógrafo" },
  { value: "Corretor De Imóvel", label: "Corretor De Imóvel" },
  { value: "Cozinheiro (A)", label: "Cozinheiro (A)" },
  { value: "Dançarino", label: "Dançarino" },
  { value: "Defensor Público", label: "Defensor Público" },
  { value: "Dermatologista", label: "Dermatologista" },
  { value: "Desembargador", label: "Desembargador" },
  { value: "Designer", label: "Designer" },
  { value: "Detetive", label: "Detetive" },
  { value: "Diarista", label: "Diarista" },
  { value: "Digitador", label: "Digitador" },
  { value: "Diretor De Empresa Pública", label: "Diretor De Empresa Pública" },
  { value: "Divulgador", label: "Divulgador" },
  { value: "Doceiro", label: "Doceiro" },
  { value: "Editor", label: "Editor" },
  { value: "Educador Social", label: "Educador Social" },
  { value: "Eletromecânico", label: "Eletromecânico" },
  { value: "Eletrotécnico", label: "Eletrotécnico" },
  { value: "Embaixador", label: "Embaixador" },
  { value: "Embalador", label: "Embalador" },
  { value: "Emissor De Turismo", label: "Emissor De Turismo" },
  { value: "Empactador", label: "Empactador" },
  { value: "Empreiteiro", label: "Empreiteiro" },
  { value: "Encanador", label: "Encanador" },
  { value: "Encarregado De Produção", label: "Encarregado De Produção" },
  { value: "Engenheiro Eletricista", label: "Engenheiro Eletricista" },
  { value: "Engenheiro Químico", label: "Engenheiro Químico" },
  { value: "Enólogo", label: "Enólogo" },
  { value: "Escrevente", label: "Escrevente" },
  { value: "Escritor", label: "Escritor" },
  { value: "Escriturário", label: "Escriturário" },
  { value: "Escrivão", label: "Escrivão" },
  { value: "Especialista", label: "Especialista" },
  { value: "Esteticista", label: "Esteticista" },
  { value: "Estilista", label: "Estilista" },
  { value: "Estoquista", label: "Estoquista" },
  { value: "Faturista", label: "Faturista" },
  { value: "Faxineira", label: "Faxineira" },
  { value: "Ferreiro", label: "Ferreiro" },
  { value: "Ferramenteiro", label: "Ferramenteiro" },
  { value: "Filósofo", label: "Filósofo" },
  { value: "Fiscal Da Receita", label: "Fiscal Da Receita" },
  { value: "Fiscal De Qualidade", label: "Fiscal De Qualidade" },
  { value: "Fiscal De Transporte", label: "Fiscal De Transporte" },
  { value: "Frentrista", label: "Frentrista" },
  { value: "Funileiro", label: "Funileiro" },
  { value: "Gari", label: "Gari" },
  { value: "Geneticista", label: "Geneticista" },
  { value: "Gerente De Produção", label: "Gerente De Produção" },
  { value: "Gerente Comercial", label: "Gerente Comercial" },
  { value: "Gerente Contábil", label: "Gerente Contábil" },
  { value: "Gerente De Contas", label: "Gerente De Contas" },
  { value: "Gerente De Loja", label: "Gerente De Loja" },
  { value: "Gerente De Marketing", label: "Gerente De Marketing" },
  { value: "Gerente De Planejamento", label: "Gerente De Planejamento" },
  { value: "Gerente De Vendas", label: "Gerente De Vendas" },
  { value: "Gerente Financeiro", label: "Gerente Financeiro" },
  { value: "Gerente Operacional", label: "Gerente Operacional" },
  { value: "Gesseiro", label: "Gesseiro" },
  { value: "Guarda-Civil", label: "Guarda-Civil" },
  { value: "Guincheiro", label: "Guincheiro" },
  { value: "Hidráulico", label: "Hidráulico" },
  { value: "Higienizador", label: "Higienizador" },
  { value: "Imediato Da Marinha", label: "Imediato Da Marinha" },
  { value: "Impermeabilizador", label: "Impermeabilizador" },
  { value: "Inspetor De Escola", label: "Inspetor De Escola" },
  {
    value: "Inspetor De Manutenção Naval",
    label: "Inspetor De Manutenção Naval"
  },
  { value: "Inspetor De Qualidade", label: "Inspetor De Qualidade" },
  { value: "Instalador", label: "Instalador" },
  { value: "Instalador De Alarme", label: "Instalador De Alarme" },
  { value: "Instrumentista", label: "Instrumentista" },
  { value: "Instrutor", label: "Instrutor" },
  { value: "Instrutor De Autoescola", label: "Instrutor De Autoescola" },
  { value: "Instrutor De Voo", label: "Instrutor De Voo" },
  { value: "Intérprete", label: "Intérprete" },
  { value: "Investigador De Polícia", label: "Investigador De Polícia" },
  { value: "Jardineiro", label: "Jardineiro" },
  { value: "Lavadeira", label: "Lavadeira" },
  { value: "Lavador", label: "Lavador" },
  { value: "Legisladores ( Vereador )", label: "Legisladores ( Vereador )" },
  { value: "Líder", label: "Líder" },
  { value: "Linguista", label: "Linguista" },
  { value: "Locutor Tv", label: "Locutor Tv" },
  { value: "Lubrificador", label: "Lubrificador" },
  { value: "Major", label: "Major" },
  { value: "Manicure", label: "Manicure" },
  { value: "Manobrista", label: "Manobrista" },
  { value: "Maquiador", label: "Maquiador" },
  { value: "Marceneiro", label: "Marceneiro" },
  { value: "Massagista", label: "Massagista" },
  { value: "Massoterapeuta", label: "Massoterapeuta" },
  {
    value: "Mecânico De Instrumento De Precisão",
    label: "Mecânico De Instrumento De Precisão"
  },
  { value: "Mecânico De Manutenção", label: "Mecânico De Manutenção" },
  { value: "Merendeiro", label: "Merendeiro" },
  { value: "Mergulhador Profissional", label: "Mergulhador Profissional" },
  {
    value: "Mestre Carpinteiro/Marceneiro",
    label: "Mestre Carpinteiro/Marceneiro"
  },
  { value: "Meteorologista", label: "Meteorologista" },
  {
    value: "Ministro De Culto Religioso",
    label: "Ministro De Culto Religioso"
  },
  { value: "Monitor", label: "Monitor" },
  { value: "Montador", label: "Montador" },
  { value: "Montador De Móveis", label: "Montador De Móveis" },
  { value: "Motoboy", label: "Motoboy" },
  { value: "Motorista De Caminhão", label: "Motorista De Caminhão" },
  { value: "Motorista Empresa Privada", label: "Motorista Empresa Privada" },
  { value: "Museólogo", label: "Museólogo" },
  { value: "Numerólogo", label: "Numerólogo" },
  { value: "Oceanógrafo", label: "Oceanógrafo" },
  {
    value: "Operador De Carga E Descarga",
    label: "Operador De Carga E Descarga"
  },
  { value: "Operador De Dragagem", label: "Operador De Dragagem" },
  { value: "Operador De Empilhadeira", label: "Operador De Empilhadeira" },
  { value: "Operador De Extração", label: "Operador De Extração" },
  {
    value: "Operador De Geração De Energia",
    label: "Operador De Geração De Energia"
  },
  { value: "Operador De Máquina", label: "Operador De Máquina" },
  {
    value: "Operador De Produção Gráfica",
    label: "Operador De Produção Gráfica"
  },
  { value: "Operador De Qualidade", label: "Operador De Qualidade" },
  { value: "Operador De Rádio / Tv", label: "Operador De Rádio / Tv" },
  { value: "Operador De Siderúrgicas", label: "Operador De Siderúrgicas" },
  { value: "Operador De Sistemas", label: "Operador De Sistemas" },
  { value: "Operador De Telemarketing", label: "Operador De Telemarketing" },
  { value: "Operador De Triagem", label: "Operador De Triagem" },
  { value: "Operador Industrial", label: "Operador Industrial" },
  { value: "Óptico", label: "Óptico" },
  { value: "Orientador", label: "Orientador" },
  { value: "Padeiro", label: "Padeiro" },
  { value: "Padre", label: "Padre" },
  { value: "Passadeira", label: "Passadeira" },
  { value: "Pastor", label: "Pastor" },
  { value: "Pedagogo", label: "Pedagogo" },
  { value: "Pedreiro", label: "Pedreiro" },
  { value: "Perito Criminal", label: "Perito Criminal" },
  { value: "Pescador", label: "Pescador" },
  { value: "Pesquisador", label: "Pesquisador" },
  { value: "Pintor", label: "Pintor" },
  { value: "Pirotécnico", label: "Pirotécnico" },
  { value: "Pizzaiolo", label: "Pizzaiolo" },
  { value: "Planejador", label: "Planejador" },
  { value: "Plataformista", label: "Plataformista" },
  { value: "Policial", label: "Policial" },
  { value: "Porteiro", label: "Porteiro" },
  { value: "Produtor", label: "Produtor" },
  { value: "Produtor Agrícola", label: "Produtor Agrícola" },
  { value: "Produtor Cultural", label: "Produtor Cultural" },
  { value: "Produtor De Espetáculos", label: "Produtor De Espetáculos" },
  { value: "Produtor De Rádio / Tv", label: "Produtor De Rádio / Tv" },
  {
    value: "Profissional Da Educação Física",
    label: "Profissional Da Educação Física"
  },
  { value: "Programador De Produção", label: "Programador De Produção" },
  { value: "Programador Ti", label: "Programador Ti" },
  { value: "Ouvidor", label: "Ouvidor" },
  { value: "Projetista", label: "Projetista" },
  { value: "Promotor", label: "Promotor" },
  { value: "Promotor De Eventos", label: "Promotor De Eventos" },
  { value: "Promotor De Vendas", label: "Promotor De Vendas" },
  { value: "Prototipista", label: "Prototipista" },
  { value: "Radialista", label: "Radialista" },
  { value: "Recenseador", label: "Recenseador" },
  { value: "Recepcionista", label: "Recepcionista" },
  { value: "Recreacionista", label: "Recreacionista" },
  { value: "Recuperador", label: "Recuperador" },
  { value: "Relojoeiro", label: "Relojoeiro" },
  { value: "Repositor De Mercadorias", label: "Repositor De Mercadorias" },
  { value: "Revendedor", label: "Revendedor" },
  { value: "Roteirista", label: "Roteirista" },
  { value: "Salgadeiro", label: "Salgadeiro" },
  { value: "Salva-Vidas", label: "Salva-Vidas" },
  { value: "Sargento", label: "Sargento" },
  { value: "Secretária", label: "Secretária" },
  { value: "Secretária Executiva", label: "Secretária Executiva" },
  { value: "Secretário De Escola", label: "Secretário De Escola" },
  { value: "Segurança", label: "Segurança" },
  { value: "Serigrafista / Tipógrafo", label: "Serigrafista / Tipógrafo" },
  { value: "Serralheiro", label: "Serralheiro" },
  { value: "Servente", label: "Servente" },
  { value: "Servente De Obras", label: "Servente De Obras" },
  { value: "Sócio", label: "Sócio" },
  { value: "Soldado", label: "Soldado" },
  { value: "Soldador", label: "Soldador" },
  { label: "Sub-Gerente", value: "Sub-Gerente" },
  { label: "Subtenente", value: "Subtenente" },
  { label: "Supervisor Administrativo", value: "Supervisor Administrativo" },
  { label: "Supervisor Agrícola", value: "Supervisor Agrícola" },
  { label: "Supervisor Comercial", value: "Supervisor Comercial" },
  { label: "Supervisor de Atendimento", value: "Supervisor de Atendimento" },
  { label: "Supervisor de Construção", value: "Supervisor de Construção" },
  {
    label: "Supervisor de Distribuição de Energia",
    value: "Supervisor de Distribuição de Energia"
  },
  { label: "Supervisor de Embalagem", value: "Supervisor de Embalagem" },
  { label: "Supervisor de Extração", value: "Supervisor de Extração" },
  { label: "Supervisor de Hotelaria", value: "Supervisor de Hotelaria" },
  { label: "Supervisor de Indústria", value: "Supervisor de Indústria" },
  { label: "Supervisor de Lavanderia", value: "Supervisor de Lavanderia" },
  { label: "Supervisor de Manutenção", value: "Supervisor de Manutenção" },
  { label: "Supervisor de Produção", value: "Supervisor de Produção" },
  { label: "Supervisor de Segurança", value: "Supervisor de Segurança" },
  { label: "Supervisor de Transporte", value: "Supervisor de Transporte" },
  { label: "Supervisor de Vendas", value: "Supervisor de Vendas" },
  { label: "Supervisor Financeiro", value: "Supervisor Financeiro" },
  { label: "Taxista", value: "Taxista" },
  { label: "Tecelão", value: "Tecelão" },
  { label: "Técnico Administrativo", value: "Técnico Administrativo" },
  {
    label: "Técnico Agrícola / Pecuária",
    value: "Técnico Agrícola / Pecuária"
  },
  { label: "Técnico de Eletrônica", value: "Técnico de Eletrônica" },
  { label: "Técnico de Laboratório", value: "Técnico de Laboratório" },
  { label: "Técnico de Mineração", value: "Técnico de Mineração" },
  { label: "Técnico em Áudio", value: "Técnico em Áudio" },
  { label: "Técnico em Biblioteconomia", value: "Técnico em Biblioteconomia" },
  {
    label: "Técnico em Construção Civil",
    value: "Técnico em Construção Civil"
  },
  { label: "Técnico de Enfermagem", value: "Técnico de Enfermagem" },
  { label: "Técnico em Farmácia", value: "Técnico em Farmácia" },
  { label: "Técnico em Informática", value: "Técnico em Informática" },
  { label: "Técnico de Manutenção", value: "Técnico de Manutenção" },
  { label: "Técnico em Radiologia", value: "Técnico em Radiologia" },
  {
    label: "Técnico em Segurança do Trabalho",
    value: "Técnico em Segurança do Trabalho"
  },
  { label: "Técnico em Seguros", value: "Técnico em Seguros" },
  { label: "Técnico Industrial", value: "Técnico Industrial" },
  { label: "Técnicos em Transportes", value: "Técnicos em Transportes" },
  { label: "Tecnólogo", value: "Tecnólogo" },
  { label: "Tenente", value: "Tenente" },
  { label: "Terapeuta", value: "Terapeuta" },
  { label: "Tesoureiro", value: "Tesoureiro" },
  { label: "Topógrafo", value: "Topógrafo" },
  { label: "Torneiro Mecânico", value: "Torneiro Mecânico" },
  { label: "Tosador", value: "Tosador" },
  { label: "Trabalhador Agrícola", value: "Trabalhador Agrícola" },
  { label: "Trabalhador em Confecção", value: "Trabalhador em Confecção" },
  { label: "Universitário", value: "Universitário" },
  { label: "Urbanista", value: "Urbanista" },
  { label: "Vendedor Autônomo", value: "Vendedor Autônomo" },
  { label: "Vice-Diretor", value: "Vice-Diretor" },
  { label: "Vidraceiro", value: "Vidraceiro" },
  { label: "Vidraceiro / Ceramista", value: "Vidraceiro / Ceramista" },
  { label: "Vigia", value: "Vigia" },
  { label: "Zootecnista", value: "Zootecnista" },
  { label: "Bioquímico", value: "Bioquímico" },
  { label: "Higienizador", value: "Higienizador" },
  { label: "Operador de Produção", value: "Operador de Produção" },
  { label: "Supervisor Hospitalar", value: "Supervisor Hospitalar" },
  { label: "Analista de Contas", value: "Analista de Contas" },
  { label: "Analista Administrativo", value: "Analista Administrativo" },
  { label: "Analista de Infraestrutura", value: "Analista de Infraestrutura" },
  { label: "Analista de Compras", value: "Analista de Compras" },
  { label: "Assistente de TI", value: "Assistente de TI" },
  { label: "Assistente de Atendimento", value: "Assistente de Atendimento" },
  { label: "Assistente Contábil", value: "Assistente Contábil" },
  { label: "Auxiliar de Farmácia", value: "Auxiliar de Farmácia" },
  { label: "Gerente Geral", value: "Gerente Geral" },
  { label: "Gerente Executivo", value: "Gerente Executivo" },
  { label: "Superintendente", value: "Superintendente" },
  { label: "Fiscal de Caixa", value: "Fiscal de Caixa" },
  { label: "Aprendiz", value: "Aprendiz" },
  { label: "Encostado INSS", value: "Encostado INSS" },
  { label: "Encarregado", value: "Encarregado" },
  { label: "Auxiliar Administrativo", value: "Auxiliar Administrativo" },
  { label: "Bioquímico", value: "Bioquímico" },
  { label: "Biomédico", value: "Biomédico" }
];

export const martialStatusByValue = {
  [MartialStatusEnum.SOLTEIRO]: "Solteiro",
  [MartialStatusEnum.CASADO]: "Casado",
  [MartialStatusEnum.DIVROCIADO]: "Divorciado",
  [MartialStatusEnum.SEPARADO_JUDICIALMENTE]: "Separado Judicialmente",
  [MartialStatusEnum.VIUVO]: "Viuvo",
  [MartialStatusEnum.OUTROS]: "Outros",
  [MartialStatusEnum.UNIAO_ESTAVEL]: "União Estável"
};

export const personTypeByValue = {
  [TIPO_PESSOA.FISICA]: "Física",
  [TIPO_PESSOA.JURIDICA]: "Jurídica"
};

export enum PROPOSAL_ACTIONS {
  SEE_PROPOSAL = "$seeProposal",
  EDIT_PROPOSAL = "$editProposal",
  EDIT_PRE_PROPOSAL = "$editPreProposal",
  EFFECTIVE_PROPOSAL = "$effectiveProposal",
  FIDELITY_EFFECTIVE = "$fidelityEffective",
  DELETE_DRAFT = "$deleteDraft",
  SEND_TO_CREDIT_TABLE = "$sendToCreditTable"
}
